export const CUSTOMER_AGENT_FEEDBACK_MESSAGE = 'CUSTOMER_AGENT_FEEDBACK';
export const POSITIVE = 'POSITIVE';
export const NEGATIVE = 'NEGATIVE';